
import axios, { AxiosError } from "axios";
import { signOut } from "@/contexts/AuthContext";
import { useRefreshToken } from "@/hooks/useRefreshToken";
import { v1 as uuidv1 } from 'uuid';


function getApiRefundPirata() {
  const token = localStorage.getItem("barte-auth-token");
  const { sendRefreshToken } = useRefreshToken()

  if (token != null) {

    const REFUND_API = axios.create({
      baseURL: `${import.meta.env.VITE_PIRATA_REFUND}`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
    REFUND_API.interceptors.request.use(
      (config) => {
        const newConfig = config;
        const uuid = uuidv1();
        newConfig.headers.post['x-idempotency-key'] = uuid;
        return newConfig;
      },
      (error) => Promise.reject(error)
    );
    REFUND_API.interceptors.response.use(
      (response) => {
        return Promise.resolve(response);
      },
      (error: AxiosError) => {
        if (error?.response?.status === 401) {
          sendRefreshToken();
        } else if (error?.response?.status === 403) {
          signOut();
        }
        return Promise.reject(error);
      }
    );
    return REFUND_API;
  }


}

export const REFUND_API = getApiRefundPirata();


